<div class="row">
  <div class="card shadow-none rounded">
    <div class="card-body">
      <div class="col-12 col-md-12 col-xxl-12 col-xl-12">
        <div class="row">
          <div class="col-12 col-xxl-10 col-xl-10 col-md-10 col-lg-10 col-sm-8">
            <h4 class="fw-bold">Financial assets - {{commonService.headerName}}</h4>
          </div>
          <div class="col-12 col-xxl-2 col-xl-2 col-md-2 col-lg-2 col-sm-4 text-start text-sm-end p-sm-0 pt-2">
            <button type="button" class="btn btn-outline-themecolorlight" style="padding: 7px;font-weight: 600; font-size: 14px;" tabindex="-1" (click)="TotalBack()">Close Accounts</button>
          </div>
        </div>
      </div>
      <hr />
      <form [formGroup]="fnancialAssestsForm ">
        <div class="col-12 col-md-12 col-xxl-12 col-xl-12 col-lg-12  col-sm-12">

          <div class="row">
            <div class="col-12">
              <!--<h5 class="fw-bolder font-size-16">
                Financial assets (Fixed asset investments)
              </h5>-->
              <p class="text-dark mb-2">Please enter notes on financial assets.</p>
              <p class="text-dark">If you do not have any notes to make, please return to the notes menu and de-select this section.</p>
            </div>
            <div class="col-12 text-end text-md-end">
              <button class="btn themedefault p-1 ps-3 pe-3 me-0" (click)="addFinancialAssets();" type="button" [disabled]="disableFinancialAssets">+ Add New</button>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">

              <div class="table-responsive" formArrayName="fnancialAssestsArray">
                <table class="tableheading table dataTable table-bordered table-striped row-border table-hover pt-10" style="white-space:nowrap !important;">
                  <thead>
                    <tr>
                      <th>Item Description</th>
                      <th>{{commonService.StartYear}}</th>
                      <th class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of formArrayControls.controls; let pointIndex=index;" [formGroupName]="pointIndex">
                      <td>
                        <input class="form-control flatpickr-input small-placeholder Companyname string caseSenstive" appNumberdirective type="text" maxlength="100" formControlName="ItemDescription" [ngClass]="{ 'is-invalid':(!valid && (formArrayControls.controls.length > 0) && (formArrayControls.controls[pointIndex].value['ItemDescription'] == null))}" />
                        <span class="text-danger" *ngIf="(!valid && (formArrayControls.controls.length > 0) && (formArrayControls.controls[pointIndex].value['ItemDescription'] == null))">Item Description is required</span>
                      </td>
                      <td>
                        <input class="form-control flatpickr-input small-placeholder text-end AccountNumber " appNumberdirective type="text" (blur)="CalculationsGrid(pointIndex)" formControlName="FinancialYear">
                      </td>
                      <td align="center" class="cursor-pointer">
                        <button class="btn  btn-sm p-1" title="Delete" [disabled]="disableFinancialAssets"><span class="fa fa-trash-can cantrash text-danger" (click)="deleteRow(pointIndex);"></span></button>
                      </td>
                    </tr>

                  </tbody>

                </table>
              </div>
              <div class="row text-center mt-2" *ngIf="!formArrayControls?.length">
                <b class="mb-2">No records found</b>
              </div>
              <div class="d-flex row justify-content-around mt-3">
                <!--<div class="col-12 text-end">
    <label class="pb-2">
      Total
    </label>
    <input type="text" formControlName="Total">
  </div>-->
                <div class="col-xxl-6 w-41 col-lg-5 col-md-4 col-sm-4 col-12 text-start text-md-end pt-2 pb-sm-0 pb-2 pe-0" *ngIf="formArrayControls?.length">
                  <span class="">Total</span>
                </div>
               
                    <div class="col-lg-10 w-40  col-xl-8 col-md-8 col-sm-8 col-12 text-end mb-2 px-0" *ngIf="formArrayControls?.length">
                      <!--<div class="input-group">
          <span class=" theme-color font-weight-600">£</span>
          <div class="input-group-text ">Total</div>
          <input type="text" class="form-control text-end" readonly placeholder="" formControlName="Total" />
        </div>-->
                      <div class="input-group mb-3">
                        <div class="input-group-text">
                          <span class=" theme-color font-weight-600">£</span>
                        </div>
                        <input type="text" class="form-control text-end" placeholder="" formControlName="Total" />
                      </div>
                    </div>
                
                <div class="w-13">
                </div>
              </div>
              <!--<div class="row mt-3">
    <div class="col-12 text-end">
      <button class="btn themedefault p-1 ps-3 pe-3 " (click)="addFinancialAssets();" type="button">+ Add New</button>
    </div>
  </div>-->
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-md-12 col-lg-12 col-sm-12">
              <label class="pb-2">
                Please enter any additional information in the field below.
              </label>
              <div class="mb-3">
                <textarea class="form-control allowSpecialChars" [appTooltip]="showBubbledata" appNumberdirective  maxlength="4000" rows="6" formControlName="FreeText"></textarea>
              </div>
            </div>
            <div class="col-12 col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-end mt-4">
              <button type="button" class="btn btn-outline-back p-1 ps-3 pe-3 me-2" (click)="On_Back()">Back</button>
              <button type="button" class="btn themedefault p-1 ps-3 pe-3 ms-1 me-0" (click)="saveFinancialassets();">Next</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
